function copyViaSelection(text: string): boolean {
  const active = document.activeElement instanceof HTMLElement ? document.activeElement : null
  const el = document.createElement('textarea')
  el.value = text
  el.setAttribute('readonly', '')
  // 16px — iOS не увеличивает страницу при фокусе; fixed — без прыжка прокрутки.
  el.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px'
  document.body.appendChild(el)
  try {
    el.focus({ preventScroll: true })
    el.select()
    // select() на iOS не выделяет текст, setSelectionRange — выделяет.
    el.setSelectionRange(0, text.length)
    return document.execCommand('copy')
  } catch {
    return false
  } finally {
    el.remove()
    active?.focus({ preventScroll: true })
  }
}

/**
 * Скопировать в буфер обмена. Звать прямо из нажатия: после сетевого
 * ожидания WebView (iOS, Telegram) копировать уже не даёт. false — не вышло,
 * показать текст для ручного копирования (`copyOrShow`).
 */
export async function copyText(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // В WebView Telegram clipboard API бывает запрещён
    }
  }
  return copyViaSelection(text)
}
